import { useEffect, useState } from "react"
import { Navigate, useLocation } from "react-router-dom"
import { useAuth } from "@/hooks/useAuth"
import { loadPanelLayouts } from "@/lib/panel-storage"

interface ProtectedRouteProps {
  children: React.ReactNode
  allowedRoles?: string[]
}

export function ProtectedRoute({ children, allowedRoles }: ProtectedRouteProps) {
  const { isAuthenticated, isLoading, user } = useAuth()
  const location = useLocation()
  /*
   * Panel yerleşimleri İÇERİKTEN ÖNCE yüklenmeli: kütüphane kayıtlı ölçüleri
   * yalnız panel grubu bağlanırken bir kez okuyor. Geç kalırsak sayfa
   * varsayılan ölçülerle açılır ve ilk sürüklemede kullanıcının sunucudaki
   * gerçek düzenini ezer.
   *
   * Tek istek, oturum başına bir kez (modül içinde tekilleştirilmiş);
   * `isLoading` zaten bir bekleme ekranı gösterdiği için kullanıcıya ek
   * gecikme olarak görünmüyor.
   */
  const [layoutsReady, setLayoutsReady] = useState(false)
  useEffect(() => {
    if (!isAuthenticated) return
    let alive = true
    loadPanelLayouts().finally(() => alive && setLayoutsReady(true))
    return () => { alive = false }
  }, [isAuthenticated])

  if (isLoading) {
    return (
      <div className="flex items-center justify-center h-screen bg-background">
        <div className="h-8 w-8 border-4 border-primary border-t-transparent rounded-full animate-spin" />
      </div>
    )
  }

  if (!isAuthenticated) {
    return <Navigate to="/giris" replace />
  }

  // Geçici şifreyle açılan hesap: önce şifre değiştirilir.
  if (user?.mustChangePassword && location.pathname !== "/sifre-degistir") {
    return <Navigate to="/sifre-degistir" replace />
  }

  if (allowedRoles && user?.role && !allowedRoles.includes(user.role)) {
    return <Navigate to="/" replace />
  }

  if (!layoutsReady) {
    return (
      <div className="flex items-center justify-center h-screen bg-background">
        <div className="h-8 w-8 border-4 border-primary border-t-transparent rounded-full animate-spin" />
      </div>
    )
  }

  return <>{children}</>
}
